import { Box, Title } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { useActiveMarkets } from '../../hooks/useActiveMarkets'
import { BenefitsBankAccountCardList } from '../BenefitsHomePage/BenefitsBankAccountCardList'

const AccountsPage = () => {
  useEffect(() => {
    track(trackingEvents.benefits.openBenefitsAccountsPage)
  }, [])

  const { activeMarkets, loading } = useActiveMarkets()

  return (
    <ResponsivePage.Body variant="full">
      <Box gap="s32">
        <Title
          variant="400"
          title={i18n.t('benefits.homepage.bank_account.title')}
          description={i18n.t('benefits.homepage.bank_account.description_legal_entities')}
        />

        <BenefitsBankAccountCardList activeMarkets={activeMarkets} loading={loading} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default AccountsPage
